//This function is used to sort the Options table
//we can sort by manual name a-z or z-a
//Language a-z or z-a
//Description a-z or z-a
//Model Year newest - oldest or oldest - newest

export function OptionTableFilter(a, b, filter) {
  switch (filter) {
    case "file_name":
      if (a.file_name > b.file_name) {
        return 1;
      }
      if (a.file_name < b.file_name) {
        return -1;
      }
      return 0;
    case "file_nameDescending":
      if (a.file_name < b.file_name) {
        return 1;
      }
      if (a.file_name > b.file_name) {
        return -1;
      }
      return 0;
    case "Lang":
      if (a.field_model_year != undefined && b.field_model_year != undefined) {
        if (a.field_model_year > b.field_model_year) {
          return 1;
        }
        if (a.field_model_year < b.field_model_year) {
          return -1;
        }
        return 0;
      } else return 0;
    case "LangDescending":
      if (a.field_model_year != undefined && b.field_model_year != undefined) {
        if (a.field_model_year < b.field_model_year) {
          return 1;
        }
        if (a.field_model_year > b.field_model_year) {
          return -1;
        }
        return 0;
      } else return 0;

    case "description":
      if (
        a.field_manual_description_final != undefined &&
        b.field_manual_description_final != undefined
      ) {
        if (
          a.field_manual_description_final < b.field_manual_description_final
        ) {
          return 1;
        }
        if (
          a.field_manual_description_final > b.field_manual_description_final
        ) {
          return -1;
        }
        return 0;
      } else return 0;
    case "descriptionDescending":
      if (
        a.field_manual_description_final != undefined &&
        b.field_manual_description_final != undefined
      ) {
        if (
          a.field_manual_description_final > b.field_manual_description_final
        ) {
          return 1;
        }
        if (
          a.field_manual_description_final < b.field_manual_description_final
        ) {
          return -1;
        }
        return 0;
      } else return 0;

    case "Year":
      if (a.field_model_year != undefined && b.field_model_year != undefined) {
        if (a.field_model_year.length <= 1) {
          return 1;
        }
        if (b.field_model_year.length <= 1) {
          return -1;
        }

        if (a.field_model_year < b.field_model_year) {
          return 1;
        }
        if (a.field_model_year > b.field_model_year) {
          return -1;
        }
        return 0;
      } else return 0;

    case "YearDescending":
      if (a.field_model_year != undefined && b.field_model_year != undefined) {
        if (a.field_model_year > b.field_model_year) {
          return 1;
        }
        if (a.field_model_year < b.field_model_year) {
          return -1;
        }
        return 0;
      } else return 0;
  }
}
